import { __decorate, __param } from 'tslib';
import { TemplateRef, Inject, Input, Directive, ElementRef, Output, InjectionToken, SkipSelf, forwardRef, EventEmitter, ChangeDetectorRef, HostBinding, Pipe, ContentChildren, Component, ChangeDetectionStrategy, ContentChild, Optional, NgModule } from '@angular/core';
import { tuiDefaultProp, typedFromEvent, preventDefault, TuiController, tuiPure, TuiDestroyService, EMPTY_QUERY, TuiTableSortKeyException, TuiMapperPipeModule } from '@taiga-ui/cdk';
import { DOCUMENT, CommonModule } from '@angular/common';
import { TUI_ELEMENT_REF, TUI_TEXTFIELD_APPEARANCE, TUI_TEXTFIELD_LABEL_OUTSIDE, TUI_TEXTFIELD_SIZE, MODE_PROVIDER, TUI_MODE, watchedControllerFactory, TuiSvgModule } from '@taiga-ui/core';
import { switchMap, distinctUntilChanged, map, takeUntil, startWith } from 'rxjs/operators';
import { IntersectionObserverService, INTERSECTION_ROOT_MARGIN, INTERSECTION_THRESHOLD } from '@ng-web-apis/intersection-observer';
import { Observable } from 'rxjs';
import { TUI_INPUT_COUNT_OPTIONS } from '@taiga-ui/kit';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { NgControl } from '@angular/forms';
import { defaultSort } from '@taiga-ui/addon-table/utils';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'rxjs';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc4 from '@taiga-ui/core';
import * as ɵngcc5 from '@taiga-ui/cdk';

const _c0 = ["tuiTr", ""];
function TuiTrComponent_ng_container_0_ng_container_1_ng_template_1_td_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.ngIf;
    const key_r3 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r7[key_r3.toString()], " ");
} }
function TuiTrComponent_ng_container_0_ng_container_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TuiTrComponent_ng_container_0_ng_container_1_ng_template_1_td_0_Template, 2, 1, "td", 4);
    ɵngcc0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r5.item$));
} }
function TuiTrComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 2);
    ɵngcc0.ɵɵtemplate(1, TuiTrComponent_ng_container_0_ng_container_1_ng_template_1_Template, 2, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const key_r3 = ctx.$implicit;
    const _r4 = ɵngcc0.ɵɵreference(2);
    const items_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", (items_r1[key_r3.toString()] == null ? null : items_r1[key_r3.toString()].template) || _r4);
} }
function TuiTrComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiTrComponent_ng_container_0_ng_container_1_Template, 3, 1, "ng-container", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.table.columns);
} }
const _c1 = ["tuiTbody", ""];
function TuiTbodyComponent_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "th", 1);
    ɵngcc0.ɵɵelementStart(2, "button", 2);
    ɵngcc0.ɵɵlistener("click", function TuiTbodyComponent_tr_1_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onClick(); });
    ɵngcc0.ɵɵelement(3, "span", 3);
    ɵngcc0.ɵɵelement(4, "tui-svg", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("colSpan", ctx_r0.table.columns.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("content", ctx_r0.heading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("chevron_rotated", ctx_r0.open);
} }
function TuiTbodyComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 6);
    ɵngcc0.ɵɵpipe(1, "tuiMapper");
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const index_r6 = ctx.index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.row.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpipeBind3(1, 2, item_r5, ctx_r4.toContext, index_r6));
} }
function TuiTbodyComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiTbodyComponent_ng_container_2_ng_container_1_Template, 2, 6, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.sorted);
} }
const _c2 = ["*"];
const _c3 = ["tuiTd", ""];
const _c4 = ["tuiTh", ""];
function TuiThComponent_button_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TuiThComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("click", function TuiThComponent_button_0_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.table.updateSorter(ctx_r5.sorter); });
    ɵngcc0.ɵɵtemplate(1, TuiThComponent_button_0_ng_container_1_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelement(4, "tui-svg", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵclassProp("t-sort_sorted", ctx_r0.isCurrent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 7, ctx_r0.table.change$), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("t-sort-icon_rotated", ctx_r0.isCurrent && ctx_r0.table.direction === -1);
    ɵngcc0.ɵɵproperty("src", ctx_r0.icon);
} }
function TuiThComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function TuiThComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵlistener("tuiResized", function TuiThComponent_div_3_Template_div_tuiResized_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onResized($event); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c5 = ["tuiThGroup", ""];
function TuiThGroupComponent_ng_container_1_ng_container_1_ng_template_1_th_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const key_r3 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(key_r3.toString());
} }
function TuiThGroupComponent_ng_container_1_ng_container_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TuiThGroupComponent_ng_container_1_ng_container_1_ng_template_1_th_0_Template, 2, 1, "th", 4);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.th && !ctx_r5.heads.length);
} }
function TuiThGroupComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 2);
    ɵngcc0.ɵɵtemplate(1, TuiThGroupComponent_ng_container_1_ng_container_1_ng_template_1_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const key_r3 = ctx.$implicit;
    const _r4 = ɵngcc0.ɵɵreference(2);
    const headings_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", (headings_r1[key_r3.toString()] == null ? null : headings_r1[key_r3.toString()].template) || _r4);
} }
function TuiThGroupComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiThGroupComponent_ng_container_1_ng_container_1_Template, 3, 1, "ng-container", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.table.columns);
} }
let TuiCellDirective = class TuiCellDirective {
    constructor(template) {
        this.template = template;
        this.tuiCell = '';
    }
};
TuiCellDirective.ɵfac = function TuiCellDirective_Factory(t) { return new (t || TuiCellDirective)(ɵngcc0.ɵɵdirectiveInject(TemplateRef)); };
TuiCellDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiCellDirective, selectors: [["", "tuiCell", ""]], inputs: { tuiCell: "tuiCell" } });
TuiCellDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Inject, args: [TemplateRef,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCellDirective.prototype, "tuiCell", void 0);
TuiCellDirective = __decorate([ __param(0, Inject(TemplateRef))
], TuiCellDirective);

let TuiHeadDirective = class TuiHeadDirective {
    constructor(template) {
        this.template = template;
    }
};
TuiHeadDirective.ɵfac = function TuiHeadDirective_Factory(t) { return new (t || TuiHeadDirective)(ɵngcc0.ɵɵdirectiveInject(TemplateRef)); };
TuiHeadDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiHeadDirective, selectors: [["", "tuiHead", ""]], inputs: { tuiHead: "tuiHead" } });
TuiHeadDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Inject, args: [TemplateRef,] }] }
];
__decorate([
    Input()
], TuiHeadDirective.prototype, "tuiHead", void 0);
TuiHeadDirective = __decorate([ __param(0, Inject(TemplateRef))
], TuiHeadDirective);

// @dynamic
let TuiResizedDirective = class TuiResizedDirective {
    constructor(documentRef, elementRef, parentRef) {
        this.documentRef = documentRef;
        this.elementRef = elementRef;
        this.parentRef = parentRef;
        this.tuiResized = typedFromEvent(this.elementRef.nativeElement, 'mousedown').pipe(preventDefault(), switchMap(() => {
            const { width, right } = this.parentRef.nativeElement.getBoundingClientRect();
            return typedFromEvent(this.documentRef, 'mousemove').pipe(distinctUntilChanged(), map(({ clientX }) => width + clientX - right), takeUntil(typedFromEvent(this.documentRef, 'mouseup')));
        }));
    }
};
TuiResizedDirective.ɵfac = function TuiResizedDirective_Factory(t) { return new (t || TuiResizedDirective)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TUI_ELEMENT_REF)); };
TuiResizedDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiResizedDirective, selectors: [["", "tuiResized", ""]], outputs: { tuiResized: "tuiResized" } });
TuiResizedDirective.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [TUI_ELEMENT_REF,] }] }
];
__decorate([
    Output()
], TuiResizedDirective.prototype, "tuiResized", void 0);
TuiResizedDirective = __decorate([ __param(0, Inject(DOCUMENT)),
    __param(1, Inject(ElementRef)),
    __param(2, Inject(TUI_ELEMENT_REF))
], TuiResizedDirective);

let TuiRowDirective = class TuiRowDirective {
    constructor(template) {
        this.template = template;
        this.tuiRowOf = [];
    }
    static ngTemplateContextGuard(_dir, _ctx) {
        return true;
    }
};
TuiRowDirective.ɵfac = function TuiRowDirective_Factory(t) { return new (t || TuiRowDirective)(ɵngcc0.ɵɵdirectiveInject(TemplateRef)); };
TuiRowDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiRowDirective, selectors: [["ng-template", "tuiRow", ""]], inputs: { tuiRowOf: "tuiRowOf" } });
TuiRowDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Inject, args: [TemplateRef,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiRowDirective.prototype, "tuiRowOf", void 0);
TuiRowDirective = __decorate([ __param(0, Inject(TemplateRef))
], TuiRowDirective);

function stuckFactory({ nativeElement }, entries$) {
    const stream$ = entries$.pipe(map(([{ intersectionRatio }]) => intersectionRatio < 1));
    nativeElement['$.class._stuck'] = stream$;
    return stream$;
}
const TUI_STUCK = new InjectionToken('Stream of sticky stuck events');
const TUI_STUCK_PROVIDER = {
    provide: TUI_STUCK,
    deps: [ElementRef, IntersectionObserverService],
    useFactory: stuckFactory,
};

// TODO: remove in ivy compilation
const TABLE_THRESHOLD = [0, 1];
const TABLE_LABEL = {
    labelOutside: true,
};
function inputCountOptionsFactory(options) {
    return Object.assign(Object.assign({}, options), { hideButtons: true });
}
const TUI_TABLE_PROVIDERS = [
    {
        provide: INTERSECTION_ROOT_MARGIN,
        useValue: '10000px 10000px 10000px 0px',
    },
    {
        provide: INTERSECTION_THRESHOLD,
        useValue: TABLE_THRESHOLD,
    },
    {
        provide: TUI_TEXTFIELD_APPEARANCE,
        // TODO: remove in ivy compilation
        useValue: 'table',
    },
    {
        provide: TUI_TEXTFIELD_LABEL_OUTSIDE,
        useValue: TABLE_LABEL,
    },
    {
        provide: TUI_INPUT_COUNT_OPTIONS,
        deps: [[new SkipSelf(), TUI_INPUT_COUNT_OPTIONS]],
        useFactory: inputCountOptionsFactory,
    },
    {
        provide: TUI_TEXTFIELD_SIZE,
        useExisting: forwardRef(() => TuiTableDirective),
    },
    IntersectionObserverService,
    MODE_PROVIDER,
    TUI_STUCK_PROVIDER,
];

let TuiTableDirective = class TuiTableDirective extends TuiController {
    constructor(entries$, mode$, stuck$, changeDetectorRef) {
        super();
        this.entries$ = entries$;
        this.mode$ = mode$;
        this.stuck$ = stuck$;
        this.changeDetectorRef = changeDetectorRef;
        this.columns = [];
        this.size = 'm';
        this.direction = 1;
        this.directionChange = new EventEmitter();
        this.sorterChange = new EventEmitter();
        this.sorter = () => 0;
    }
    updateSorter(sorter) {
        if (this.sorter === sorter) {
            this.direction = this.direction === 1 ? -1 : 1;
            this.directionChange.emit(this.direction);
        }
        else {
            this.sorter = sorter;
            this.sorterChange.emit(this.sorter);
            this.direction = 1;
            this.directionChange.emit(1);
        }
        this.change$.next();
    }
    ngAfterViewInit() {
        this.changeDetectorRef.detectChanges();
    }
};
TuiTableDirective.ɵfac = function TuiTableDirective_Factory(t) { return new (t || TuiTableDirective)(ɵngcc0.ɵɵdirectiveInject(IntersectionObserverService), ɵngcc0.ɵɵdirectiveInject(TUI_MODE), ɵngcc0.ɵɵdirectiveInject(TUI_STUCK), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef)); };
TuiTableDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiTableDirective, selectors: [["table", "tuiTable", ""]], hostAttrs: [2, "border-collapse", "separate"], hostVars: 1, hostBindings: function TuiTableDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("$.data-mode.attr", function TuiTableDirective___data_mode_attr_HostBindingHandler() { return ctx.mode$; })("$.class._stuck", function TuiTableDirective___class__stuck_HostBindingHandler() { return ctx.stuck$; });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-size", ctx.size);
    } }, inputs: { columns: "columns", size: "size", direction: "direction", sorter: "sorter" }, outputs: { directionChange: "directionChange", sorterChange: "sorterChange" }, features: [ɵngcc0.ɵɵProvidersFeature(TUI_TABLE_PROVIDERS), ɵngcc0.ɵɵInheritDefinitionFeature] });
TuiTableDirective.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [IntersectionObserverService,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_MODE,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_STUCK,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTableDirective.prototype, "columns", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-size'),
    tuiDefaultProp()
], TuiTableDirective.prototype, "size", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTableDirective.prototype, "direction", void 0);
__decorate([
    Output()
], TuiTableDirective.prototype, "directionChange", void 0);
__decorate([
    Output()
], TuiTableDirective.prototype, "sorterChange", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTableDirective.prototype, "sorter", void 0);
TuiTableDirective = __decorate([ __param(0, Inject(IntersectionObserverService)),
    __param(1, Inject(TUI_MODE)),
    __param(2, Inject(TUI_STUCK)),
    __param(3, Inject(ChangeDetectorRef))
], TuiTableDirective);

let TuiTheadDirective = class TuiTheadDirective {
    constructor(stuck$) {
        this.stuck$ = stuck$;
    }
};
TuiTheadDirective.ɵfac = function TuiTheadDirective_Factory(t) { return new (t || TuiTheadDirective)(ɵngcc0.ɵɵdirectiveInject(TUI_STUCK)); };
TuiTheadDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiTheadDirective, selectors: [["thead", "tuiThead", ""]], hostBindings: function TuiTheadDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("$.class._stuck", function TuiTheadDirective___class__stuck_HostBindingHandler() { return ctx.stuck$; });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            TUI_STUCK_PROVIDER,
            IntersectionObserverService,
            {
                provide: INTERSECTION_ROOT_MARGIN,
                useValue: '0px 10000px 10000px 10000px'
            },
        ])] });
TuiTheadDirective.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [TUI_STUCK,] }] }
];
TuiTheadDirective = __decorate([ __param(0, Inject(TUI_STUCK))
], TuiTheadDirective);

let TuiTableSortPipe = class TuiTableSortPipe {
    constructor(table) {
        this.table = table;
    }
    transform(data) {
        return this.sort(data, this.table.sorter, this.table.direction);
    }
    sort(data, sorter, direction) {
        return [...data].sort((a, b) => direction * sorter(a, b));
    }
};
TuiTableSortPipe.ɵfac = function TuiTableSortPipe_Factory(t) { return new (t || TuiTableSortPipe)(ɵngcc0.ɵɵdirectiveInject(TuiTableDirective)); };
TuiTableSortPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "tuiTableSort", type: TuiTableSortPipe, pure: false });
TuiTableSortPipe.ctorParameters = () => [
    { type: TuiTableDirective, decorators: [{ type: Inject, args: [TuiTableDirective,] }] }
];
__decorate([
    tuiPure
], TuiTableSortPipe.prototype, "sort", null);
TuiTableSortPipe = __decorate([ __param(0, Inject(TuiTableDirective))
], TuiTableSortPipe);

// TODO: remove in ivy compilation
const TABLE_FACTORY = watchedControllerFactory;
const TUI_TABLE_PROVIDER = [
    TuiDestroyService,
    TuiTableSortPipe,
    {
        provide: TuiTableDirective,
        deps: [[new SkipSelf(), TuiTableDirective], ChangeDetectorRef, TuiDestroyService],
        useFactory: TABLE_FACTORY,
    },
];

let TuiTrComponent = class TuiTrComponent {
    constructor(table, body) {
        this.table = table;
        this.body = body;
        this.cells = EMPTY_QUERY;
        this.cells$ = this.cells.changes.pipe(startWith(null), map(() => this.cells.reduce((record, item) => (Object.assign(Object.assign({}, record), { [item.tuiCell]: item })), {})));
        this.item$ = this.body.rows.changes.pipe(startWith(null), map(() => this.body.sorted[this.body.rows.toArray().findIndex(row => row === this)]));
    }
};
TuiTrComponent.ɵfac = function TuiTrComponent_Factory(t) { return new (t || TuiTrComponent)(ɵngcc0.ɵɵdirectiveInject(forwardRef(() => TuiTableDirective)), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => TuiTbodyComponent))); };
TuiTrComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiTrComponent, selectors: [["tr", "tuiTr", ""]], contentQueries: function TuiTrComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiCellDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cells = _t);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([TUI_TABLE_PROVIDER])], attrs: _c0, decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet"], ["plain", ""], ["tuiTd", "", 4, "ngIf"], ["tuiTd", ""]], template: function TuiTrComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiTrComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.cells$));
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc2.NgTemplateOutlet, TuiTdComponent]; }, pipes: function () { return [ɵngcc2.AsyncPipe]; }, encapsulation: 2, changeDetection: 0 });
TuiTrComponent.ctorParameters = () => [
    { type: TuiTableDirective, decorators: [{ type: Inject, args: [forwardRef(() => TuiTableDirective),] }] },
    { type: TuiTbodyComponent, decorators: [{ type: Inject, args: [forwardRef(() => TuiTbodyComponent),] }] }
];
__decorate([
    ContentChildren(forwardRef(() => TuiCellDirective))
], TuiTrComponent.prototype, "cells", void 0);
TuiTrComponent = __decorate([ __param(0, Inject(forwardRef(() => TuiTableDirective))),
    __param(1, Inject(forwardRef(() => TuiTbodyComponent)))
], TuiTrComponent);

let TuiTbodyComponent = class TuiTbodyComponent {
    constructor(pipe, table) {
        this.pipe = pipe;
        this.table = table;
        this.data = [];
        this.heading = '';
        this.open = true;
        this.openChange = new EventEmitter();
        this.rows = EMPTY_QUERY;
        this.toContext = ($implicit, index) => ({ $implicit, index });
    }
    get sorted() {
        return this.pipe.transform(this.data);
    }
    onClick() {
        this.open = !this.open;
        this.openChange.emit(this.open);
    }
};
TuiTbodyComponent.ɵfac = function TuiTbodyComponent_Factory(t) { return new (t || TuiTbodyComponent)(ɵngcc0.ɵɵdirectiveInject(TuiTableSortPipe), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => TuiTableDirective))); };
TuiTbodyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiTbodyComponent, selectors: [["tbody", "tuiTbody", ""]], contentQueries: function TuiTbodyComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiRowDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiTrComponent, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.row = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rows = _t);
    } }, inputs: { data: "data", heading: "heading", open: "open" }, outputs: { openChange: "openChange" }, features: [ɵngcc0.ɵɵProvidersFeature(TUI_TABLE_PROVIDER)], attrs: _c1, ngContentSelectors: _c2, decls: 3, vars: 2, consts: [[4, "ngIf"], [1, "heading", 3, "colSpan"], ["type", "button", 1, "expand", 3, "click"], ["polymorpheus-outlet", "", 1, "name", 3, "content"], ["src", "tuiIconChevronDownLarge", 1, "chevron"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function TuiTbodyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵtemplate(1, TuiTbodyComponent_tr_1_Template, 5, 4, "tr", 0);
        ɵngcc0.ɵɵtemplate(2, TuiTbodyComponent_ng_container_2_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.heading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.open && ctx.row);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.PolymorpheusOutletComponent, ɵngcc4.TuiSvgComponent, ɵngcc2.NgForOf, ɵngcc2.NgTemplateOutlet], pipes: [ɵngcc5.TuiMapperPipe], styles: ["[_nghost-%COMP%]{border-color:var(--tui-base-04)}[_nghost-%COMP%]   tr[_ngcontent-%COMP%]{border-color:inherit}.expand[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:0 0;font-size:inherit;line-height:inherit;display:flex;width:100%;height:100%;align-items:center;box-sizing:border-box;outline:0;font-weight:700;cursor:pointer;border-color:inherit}.expand[_ngcontent-%COMP%]:focus-visible   .name[_ngcontent-%COMP%]{background:var(--tui-selection)}.expand[_ngcontent-%COMP%]:after, .expand[_ngcontent-%COMP%]:before{content:'';position:-webkit-sticky;position:sticky;height:100%;border-left:1px solid;border-color:inherit}.expand[_ngcontent-%COMP%]:before{left:0}.expand[_ngcontent-%COMP%]:after{right:0}.heading[_ngcontent-%COMP%]{height:var(--tui-height-m);font:var(--tui-font-text-s);padding:0;background:var(--tui-base-02);border-bottom:1px solid var(--tui-base-04);border-color:inherit}table[data-size='l'][_nghost-%COMP%]   .heading[_ngcontent-%COMP%], table[data-size='l']   [_nghost-%COMP%]   .heading[_ngcontent-%COMP%]{font:var(--tui-font-text-m);height:var(--tui-height-l)}.name[_ngcontent-%COMP%]{position:-webkit-sticky;position:sticky;left:.75rem;display:inline-block}table[data-size='l'][_nghost-%COMP%]   .name[_ngcontent-%COMP%], table[data-size='l']   [_nghost-%COMP%]   .name[_ngcontent-%COMP%]{left:1rem}.chevron[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:-webkit-sticky;position:sticky;right:.75rem;margin:0 .6875rem 0 auto}.chevron_rotated[_ngcontent-%COMP%]{transform:rotate(180deg)}"], changeDetection: 0 });
TuiTbodyComponent.ctorParameters = () => [
    { type: TuiTableSortPipe, decorators: [{ type: Inject, args: [TuiTableSortPipe,] }] },
    { type: TuiTableDirective, decorators: [{ type: Inject, args: [forwardRef(() => TuiTableDirective),] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTbodyComponent.prototype, "data", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTbodyComponent.prototype, "heading", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTbodyComponent.prototype, "open", void 0);
__decorate([
    Output()
], TuiTbodyComponent.prototype, "openChange", void 0);
__decorate([
    ContentChild(forwardRef(() => TuiRowDirective))
], TuiTbodyComponent.prototype, "row", void 0);
__decorate([
    ContentChildren(forwardRef(() => TuiTrComponent))
], TuiTbodyComponent.prototype, "rows", void 0);
TuiTbodyComponent = __decorate([ __param(0, Inject(TuiTableSortPipe)),
    __param(1, Inject(forwardRef(() => TuiTableDirective)))
], TuiTbodyComponent);

let TuiTdComponent = class TuiTdComponent {
};
TuiTdComponent.ɵfac = function TuiTdComponent_Factory(t) { return new (t || TuiTdComponent)(); };
TuiTdComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiTdComponent, selectors: [["th", "tuiTd", ""], ["td", "tuiTd", ""]], contentQueries: function TuiTdComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgControl, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.control = _t.first);
    } }, hostVars: 2, hostBindings: function TuiTdComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_editable", ctx.control);
    } }, attrs: _c3, ngContentSelectors: _c2, decls: 2, vars: 0, consts: [[1, "wrapper"]], template: function TuiTdComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%]{position:relative;height:var(--tui-height-m);font:var(--tui-font-text-s);text-align:left;padding:0 .75rem;background:var(--tui-base-01);border:1px solid var(--tui-base-04);border-top:none}[_nghost-%COMP%]:first-child{left:0}[_nghost-%COMP%]:not(:first-child){border-left:none}._editable[_nghost-%COMP%]:focus-within{z-index:1}._editable[_nghost-%COMP%]{padding:0}th[_nghost-%COMP%]{position:-webkit-sticky;position:sticky;z-index:1}th[_nghost-%COMP%]:after{transition-property:opacity;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;content:'';position:absolute;top:0;bottom:0;left:100%;width:.3125rem;pointer-events:none;background:rgba(237,237,237,.7);opacity:0}th[_nghost-%COMP%]:focus-within:not(:disabled){z-index:11}table[data-mode=onDark][_nghost-%COMP%]:after, table[data-mode=onDark]   [_nghost-%COMP%]:after{background:rgba(60,60,60,.9)}table._stuck[_nghost-%COMP%], table._stuck   [_nghost-%COMP%]{z-index:10}table._stuck[_nghost-%COMP%]:last-of-type:after, table._stuck   [_nghost-%COMP%]:last-of-type:after{opacity:1}table[data-size='l'][_nghost-%COMP%], table[data-size='l']   [_nghost-%COMP%]{font:var(--tui-font-text-m);height:var(--tui-height-l);padding:0 1rem}table[data-size='l']._editable[_nghost-%COMP%], table[data-size='l']   ._editable[_nghost-%COMP%]{padding:0}td[_nghost-%COMP%]:focus-within{z-index:1}td[_nghost-%COMP%]:not(:focus-within){z-index:0}.wrapper[_ngcontent-%COMP%]{margin:-1px -1px -1px 0}"], changeDetection: 0 });
__decorate([
    HostBinding('class._editable'),
    ContentChild(NgControl)
], TuiTdComponent.prototype, "control", void 0);

let TuiThComponent = class TuiThComponent {
    constructor(head, table) {
        this.head = head;
        this.table = table;
        this.sorter = this.head
            ? (a, b) => defaultSort(a[this.key], b[this.key])
            : null;
        this.resizable = false;
        this.sticky = false;
        this.width = null;
    }
    get key() {
        if (!this.head) {
            throw new TuiTableSortKeyException();
        }
        return this.head.tuiHead;
    }
    get isCurrent() {
        return !!this.sorter && !!this.table && this.sorter === this.table.sorter;
    }
    get icon() {
        return this.isCurrent ? 'tuiIconSortDown' : 'tuiIconSortOff';
    }
    onResized(width) {
        this.width = width;
    }
};
TuiThComponent.ɵfac = function TuiThComponent_Factory(t) { return new (t || TuiThComponent)(ɵngcc0.ɵɵdirectiveInject(TuiHeadDirective, 8), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => TuiTableDirective), 8)); };
TuiThComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiThComponent, selectors: [["th", "tuiTh", ""]], hostVars: 4, hostBindings: function TuiThComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px");
        ɵngcc0.ɵɵclassProp("_sticky", ctx.sticky);
    } }, inputs: { sorter: "sorter", resizable: "resizable", sticky: "sticky" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_ELEMENT_REF,
                useExisting: ElementRef
            },
        ])], attrs: _c4, ngContentSelectors: _c2, decls: 4, vars: 3, consts: [["type", "button", "class", "t-sort", 3, "t-sort_sorted", "click", 4, "ngIf", "ngIfElse"], ["content", ""], ["class", "t-bar", 3, "tuiResized", 4, "ngIf"], ["type", "button", 1, "t-sort", 3, "click"], [4, "ngTemplateOutlet"], [1, "t-sort-icon", 3, "src"], [1, "t-bar", 3, "tuiResized"]], template: function TuiThComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TuiThComponent_button_0_Template, 5, 9, "button", 0);
        ɵngcc0.ɵɵtemplate(1, TuiThComponent_ng_template_1_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, TuiThComponent_div_3_Template, 1, 0, "div", 2);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sorter && ctx.table)("ngIfElse", _r1);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.resizable);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc4.TuiSvgComponent, TuiResizedDirective], pipes: [ɵngcc2.AsyncPipe], styles: ["[_nghost-%COMP%]{transition-property:box-shadow;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:relative;top:0;z-index:20;height:var(--tui-height-m);font:var(--tui-font-text-s);text-align:left;font-weight:700;color:var(--tui-text-02);background:var(--tui-base-01);cursor:default;padding:0 .75rem;box-sizing:border-box;box-shadow:0 .3125rem rgba(237,237,237,0);border:1px solid var(--tui-base-04)}[_nghost-%COMP%]:not(:first-child){border-left:none}._sticky[_nghost-%COMP%]{position:-webkit-sticky;position:sticky;z-index:30}._sticky[_nghost-%COMP%]:first-child{left:0}._sticky[_nghost-%COMP%]:after{transition-property:opacity;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;content:'';position:absolute;top:0;left:100%;bottom:0;width:.3125rem;pointer-events:none;background:rgba(237,237,237,.7);opacity:0}tr[_nghost-%COMP%]:not(:first-child), tr:not(:first-child)   [_nghost-%COMP%]{border-top:none}table[data-size='l'][_nghost-%COMP%], table[data-size='l']   [_nghost-%COMP%]{height:var(--tui-height-l);font:var(--tui-font-text-m);font-weight:700;padding:0 1rem}thead[tuiThead][_nghost-%COMP%], thead[tuiThead]   [_nghost-%COMP%]{position:-webkit-sticky;position:sticky}table._stuck._sticky[_nghost-%COMP%]:after, table._stuck   ._sticky[_nghost-%COMP%]:after{opacity:1}thead[tuiThead]._stuck[_nghost-%COMP%], thead[tuiThead]._stuck   [_nghost-%COMP%]{box-shadow:0 .3125rem rgba(237,237,237,.7)}table[data-mode=onDark][_nghost-%COMP%]:after, table[data-mode=onDark]   [_nghost-%COMP%]:after{background:rgba(60,60,60,.9)}table[data-mode=onDark]thead[tuiThead]._stuck[_nghost-%COMP%], table[data-mode=onDark]thead[tuiThead]._stuck   [_nghost-%COMP%]{box-shadow:0 .3125rem rgba(60,60,60,.9)}table[data-mode=onDark]thead[tuiThead]._stuck[_nghost-%COMP%]:first-child, table[data-mode=onDark]thead[tuiThead]._stuck   [_nghost-%COMP%]:first-child{box-shadow:.0625rem .3125rem rgba(60,60,60,.9)}table[data-size='l']thead[tuiThead]tr[_nghost-%COMP%]:nth-child(2), table[data-size='l']thead[tuiThead]tr:nth-child(2)   [_nghost-%COMP%]{top:var(--tui-height-l)}table[data-size='m']thead[tuiThead]tr[_nghost-%COMP%]:nth-child(2), table[data-size='m']thead[tuiThead]tr:nth-child(2)   [_nghost-%COMP%]{top:var(--tui-height-m)}table[data-size='s']thead[tuiThead]tr[_nghost-%COMP%]:nth-child(2), table[data-size='s']thead[tuiThead]tr:nth-child(2)   [_nghost-%COMP%]{top:var(--tui-height-s)}.t-sort[_ngcontent-%COMP%]{transition-property:color;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:0 0;font-size:inherit;line-height:inherit;display:inline-flex;flex-direction:inherit;align-items:center;outline:0;font-weight:700;cursor:pointer}.t-sort_sorted[_ngcontent-%COMP%]{color:var(--tui-text-01)}.t-sort_sorted[_ngcontent-%COMP%]   .t-sort-icon_rotated[_ngcontent-%COMP%]{transform:scaleY(-1)}.t-sort[_ngcontent-%COMP%]:focus-visible{background:var(--tui-selection)}.t-sort[_ngcontent-%COMP%]:hover{color:var(--tui-text-01)}.t-bar[_ngcontent-%COMP%]{transition-property:opacity;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:absolute;top:0;bottom:0;right:-1px;width:3px;justify-self:flex-end;border-left:2px solid transparent;background:var(--tui-support-12);background-clip:content-box;cursor:ew-resize;opacity:0}.t-bar[_ngcontent-%COMP%]:active, .t-bar[_ngcontent-%COMP%]:hover{opacity:1}"], changeDetection: 0 });
TuiThComponent.ctorParameters = () => [
    { type: TuiHeadDirective, decorators: [{ type: Optional }, { type: Inject, args: [TuiHeadDirective,] }] },
    { type: TuiTableDirective, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => TuiTableDirective),] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiThComponent.prototype, "sorter", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiThComponent.prototype, "resizable", void 0);
__decorate([
    Input(),
    HostBinding('class._sticky'),
    tuiDefaultProp()
], TuiThComponent.prototype, "sticky", void 0);
__decorate([
    HostBinding('style.width.px')
], TuiThComponent.prototype, "width", void 0);
TuiThComponent = __decorate([ __param(0, Optional()),
    __param(0, Inject(TuiHeadDirective)),
    __param(1, Optional()),
    __param(1, Inject(forwardRef(() => TuiTableDirective)))
], TuiThComponent);

let TuiThGroupComponent = class TuiThGroupComponent {
    constructor(table) {
        this.table = table;
        this.heads = EMPTY_QUERY;
        this.heads$ = this.heads.changes.pipe(startWith(null), map(() => this.heads.reduce((record, item) => (Object.assign(Object.assign({}, record), { [item.tuiHead]: item })), {})));
    }
};
TuiThGroupComponent.ɵfac = function TuiThGroupComponent_Factory(t) { return new (t || TuiThGroupComponent)(ɵngcc0.ɵɵdirectiveInject(forwardRef(() => TuiTableDirective))); };
TuiThGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiThGroupComponent, selectors: [["tr", "tuiThGroup", ""]], contentQueries: function TuiThGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiThComponent, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiHeadDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.th = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.heads = _t);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([TUI_TABLE_PROVIDER])], attrs: _c5, ngContentSelectors: _c2, decls: 3, vars: 3, consts: [[4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet"], ["plain", ""], ["tuiTh", "", 4, "ngIf"], ["tuiTh", ""]], template: function TuiThGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵtemplate(1, TuiThGroupComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵpipe(2, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx.heads$));
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc2.NgTemplateOutlet, TuiThComponent], pipes: [ɵngcc2.AsyncPipe], encapsulation: 2, changeDetection: 0 });
TuiThGroupComponent.ctorParameters = () => [
    { type: TuiTableDirective, decorators: [{ type: Inject, args: [forwardRef(() => TuiTableDirective),] }] }
];
__decorate([
    ContentChild(forwardRef(() => TuiThComponent))
], TuiThGroupComponent.prototype, "th", void 0);
__decorate([
    ContentChildren(forwardRef(() => TuiHeadDirective))
], TuiThGroupComponent.prototype, "heads", void 0);
TuiThGroupComponent = __decorate([ __param(0, Inject(forwardRef(() => TuiTableDirective)))
], TuiThGroupComponent);

let TuiTableModule = class TuiTableModule {
};
TuiTableModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiTableModule });
TuiTableModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiTableModule_Factory(t) { return new (t || TuiTableModule)(); }, imports: [[CommonModule, PolymorpheusModule, TuiMapperPipeModule, TuiSvgModule]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiCellDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiCell]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Inject,
                args: [TemplateRef]
            }] }]; }, { tuiCell: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiHeadDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiHead]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Inject,
                args: [TemplateRef]
            }] }]; }, { tuiHead: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiResizedDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiResized]'
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [TUI_ELEMENT_REF]
            }] }]; }, { tuiResized: [{
            type: Output
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiRowDirective, [{
        type: Directive,
        args: [{
                selector: 'ng-template[tuiRow]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Inject,
                args: [TemplateRef]
            }] }]; }, { tuiRowOf: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTableDirective, [{
        type: Directive,
        args: [{
                selector: 'table[tuiTable]',
                providers: TUI_TABLE_PROVIDERS,
                host: {
                    '($.data-mode.attr)': 'mode$',
                    '($.class._stuck)': 'stuck$',
                    style: 'border-collapse: separate'
                }
            }]
    }], function () { return [{ type: ɵngcc1.Observable, decorators: [{
                type: Inject,
                args: [IntersectionObserverService]
            }] }, { type: ɵngcc1.Observable, decorators: [{
                type: Inject,
                args: [TUI_MODE]
            }] }, { type: ɵngcc1.Observable, decorators: [{
                type: Inject,
                args: [TUI_STUCK]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }]; }, { columns: [{
            type: Input
        }], size: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-size']
        }], direction: [{
            type: Input
        }], directionChange: [{
            type: Output
        }], sorterChange: [{
            type: Output
        }], sorter: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTheadDirective, [{
        type: Directive,
        args: [{
                selector: 'thead[tuiThead]',
                providers: [
                    TUI_STUCK_PROVIDER,
                    IntersectionObserverService,
                    {
                        provide: INTERSECTION_ROOT_MARGIN,
                        useValue: '0px 10000px 10000px 10000px'
                    },
                ],
                host: {
                    '($.class._stuck)': 'stuck$'
                }
            }]
    }], function () { return [{ type: ɵngcc1.Observable, decorators: [{
                type: Inject,
                args: [TUI_STUCK]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTableSortPipe, [{
        type: Pipe,
        args: [{
                name: 'tuiTableSort',
                pure: false
            }]
    }], function () { return [{ type: TuiTableDirective, decorators: [{
                type: Inject,
                args: [TuiTableDirective]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTrComponent, [{
        type: Component,
        args: [{
                selector: 'tr[tuiTr]',
                template: "<ng-container *ngIf=\"cells$ | async as items\">\n    <ng-container\n        *ngFor=\"let key of table.columns\"\n        [ngTemplateOutlet]=\"items[key.toString()]?.template || plain\"\n    >\n        <ng-template #plain>\n            <td *ngIf=\"item$ | async as item\" tuiTd>\n                {{ item[key.toString()] }}\n            </td>\n        </ng-template>\n    </ng-container>\n</ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [TUI_TABLE_PROVIDER]
            }]
    }], function () { return [{ type: TuiTableDirective, decorators: [{
                type: Inject,
                args: [forwardRef(() => TuiTableDirective)]
            }] }, { type: TuiTbodyComponent, decorators: [{
                type: Inject,
                args: [forwardRef(() => TuiTbodyComponent)]
            }] }]; }, { cells: [{
            type: ContentChildren,
            args: [forwardRef(() => TuiCellDirective)]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTbodyComponent, [{
        type: Component,
        args: [{
                selector: 'tbody[tuiTbody]',
                template: "<ng-content></ng-content>\n<tr *ngIf=\"heading\">\n    <th class=\"heading\" [colSpan]=\"table.columns.length\">\n        <button type=\"button\" class=\"expand\" (click)=\"onClick()\">\n            <span polymorpheus-outlet class=\"name\" [content]=\"heading\"></span>\n            <tui-svg\n                src=\"tuiIconChevronDownLarge\"\n                class=\"chevron\"\n                [class.chevron_rotated]=\"open\"\n            ></tui-svg>\n        </button>\n    </th>\n</tr>\n<ng-container *ngIf=\"open && row\">\n    <ng-container\n        *ngFor=\"let item of sorted; let index = index\"\n        [ngTemplateOutlet]=\"row.template\"\n        [ngTemplateOutletContext]=\"item | tuiMapper: toContext:index\"\n    ></ng-container>\n</ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: TUI_TABLE_PROVIDER,
                styles: [":host{border-color:var(--tui-base-04)}:host tr{border-color:inherit}.expand{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:0 0;font-size:inherit;line-height:inherit;display:flex;width:100%;height:100%;align-items:center;box-sizing:border-box;outline:0;font-weight:700;cursor:pointer;border-color:inherit}.expand:focus-visible .name{background:var(--tui-selection)}.expand:after,.expand:before{content:'';position:-webkit-sticky;position:sticky;height:100%;border-left:1px solid;border-color:inherit}.expand:before{left:0}.expand:after{right:0}.heading{height:var(--tui-height-m);font:var(--tui-font-text-s);padding:0;background:var(--tui-base-02);border-bottom:1px solid var(--tui-base-04);border-color:inherit}:host-context(table[data-size='l']) .heading{font:var(--tui-font-text-m);height:var(--tui-height-l)}.name{position:-webkit-sticky;position:sticky;left:.75rem;display:inline-block}:host-context(table[data-size='l']) .name{left:1rem}.chevron{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:-webkit-sticky;position:sticky;right:.75rem;margin:0 .6875rem 0 auto}.chevron_rotated{transform:rotate(180deg)}"]
            }]
    }], function () { return [{ type: TuiTableSortPipe, decorators: [{
                type: Inject,
                args: [TuiTableSortPipe]
            }] }, { type: TuiTableDirective, decorators: [{
                type: Inject,
                args: [forwardRef(() => TuiTableDirective)]
            }] }]; }, { data: [{
            type: Input
        }], heading: [{
            type: Input
        }], open: [{
            type: Input
        }], openChange: [{
            type: Output
        }], rows: [{
            type: ContentChildren,
            args: [forwardRef(() => TuiTrComponent)]
        }], row: [{
            type: ContentChild,
            args: [forwardRef(() => TuiRowDirective)]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTdComponent, [{
        type: Component,
        args: [{
                selector: 'th[tuiTd], td[tuiTd]',
                template: "<div class=\"wrapper\">\n    <ng-content></ng-content>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{position:relative;height:var(--tui-height-m);font:var(--tui-font-text-s);text-align:left;padding:0 .75rem;background:var(--tui-base-01);border:1px solid var(--tui-base-04);border-top:none}:host:first-child{left:0}:host:not(:first-child){border-left:none}:host._editable:focus-within{z-index:1}:host._editable{padding:0}:host(th){position:-webkit-sticky;position:sticky;z-index:1}:host(th):after{transition-property:opacity;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;content:'';position:absolute;top:0;bottom:0;left:100%;width:.3125rem;pointer-events:none;background:rgba(237,237,237,.7);opacity:0}:host(th):focus-within:not(:disabled){z-index:11}:host-context(table[data-mode=onDark]):after{background:rgba(60,60,60,.9)}:host-context(table._stuck){z-index:10}:host-context(table._stuck):last-of-type:after{opacity:1}:host-context(table[data-size='l']){font:var(--tui-font-text-m);height:var(--tui-height-l);padding:0 1rem}:host-context(table[data-size='l'])._editable{padding:0}:host(td):focus-within{z-index:1}:host(td):not(:focus-within){z-index:0}.wrapper{margin:-1px -1px -1px 0}"]
            }]
    }], null, { control: [{
            type: HostBinding,
            args: ['class._editable']
        }, {
            type: ContentChild,
            args: [NgControl]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiThComponent, [{
        type: Component,
        args: [{
                selector: 'th[tuiTh]',
                template: "<button\n    *ngIf=\"sorter && table; else content\"\n    type=\"button\"\n    class=\"t-sort\"\n    [class.t-sort_sorted]=\"isCurrent\"\n    (click)=\"table.updateSorter(sorter)\"\n>\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n    {{ table.change$ | async }}\n    <tui-svg\n        class=\"t-sort-icon\"\n        [src]=\"icon\"\n        [class.t-sort-icon_rotated]=\"isCurrent && table.direction === -1\"\n    ></tui-svg>\n</button>\n<ng-template #content><ng-content></ng-content></ng-template>\n<div *ngIf=\"resizable\" class=\"t-bar\" (tuiResized)=\"onResized($event)\"></div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_ELEMENT_REF,
                        useExisting: ElementRef
                    },
                ],
                styles: [":host{transition-property:box-shadow;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:relative;top:0;z-index:20;height:var(--tui-height-m);font:var(--tui-font-text-s);text-align:left;font-weight:700;color:var(--tui-text-02);background:var(--tui-base-01);cursor:default;padding:0 .75rem;box-sizing:border-box;box-shadow:0 .3125rem rgba(237,237,237,0);border:1px solid var(--tui-base-04)}:host:not(:first-child){border-left:none}:host._sticky{position:-webkit-sticky;position:sticky;z-index:30}:host._sticky:first-child{left:0}:host._sticky:after{transition-property:opacity;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;content:'';position:absolute;top:0;left:100%;bottom:0;width:.3125rem;pointer-events:none;background:rgba(237,237,237,.7);opacity:0}:host-context(tr:not(:first-child)){border-top:none}:host-context(table[data-size='l']){height:var(--tui-height-l);font:var(--tui-font-text-m);font-weight:700;padding:0 1rem}:host-context(thead[tuiThead]){position:-webkit-sticky;position:sticky}:host-context(table._stuck)._sticky:after{opacity:1}:host-context(thead[tuiThead]._stuck){box-shadow:0 .3125rem rgba(237,237,237,.7)}:host-context(table[data-mode=onDark]):after{background:rgba(60,60,60,.9)}:host-context(table[data-mode=onDark]thead[tuiThead]._stuck){box-shadow:0 .3125rem rgba(60,60,60,.9)}:host-context(table[data-mode=onDark]thead[tuiThead]._stuck):first-child{box-shadow:.0625rem .3125rem rgba(60,60,60,.9)}:host-context(table[data-size='l']thead[tuiThead]tr:nth-child(2)){top:var(--tui-height-l)}:host-context(table[data-size='m']thead[tuiThead]tr:nth-child(2)){top:var(--tui-height-m)}:host-context(table[data-size='s']thead[tuiThead]tr:nth-child(2)){top:var(--tui-height-s)}.t-sort{transition-property:color;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:0 0;font-size:inherit;line-height:inherit;display:inline-flex;flex-direction:inherit;align-items:center;outline:0;font-weight:700;cursor:pointer}.t-sort_sorted{color:var(--tui-text-01)}.t-sort_sorted .t-sort-icon_rotated{transform:scaleY(-1)}.t-sort:focus-visible{background:var(--tui-selection)}.t-sort:hover{color:var(--tui-text-01)}.t-bar{transition-property:opacity;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:absolute;top:0;bottom:0;right:-1px;width:3px;justify-self:flex-end;border-left:2px solid transparent;background:var(--tui-support-12);background-clip:content-box;cursor:ew-resize;opacity:0}.t-bar:active,.t-bar:hover{opacity:1}"]
            }]
    }], function () { return [{ type: TuiHeadDirective, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [TuiHeadDirective]
            }] }, { type: TuiTableDirective, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [forwardRef(() => TuiTableDirective)]
            }] }]; }, { sorter: [{
            type: Input
        }], resizable: [{
            type: Input
        }], sticky: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class._sticky']
        }], width: [{
            type: HostBinding,
            args: ['style.width.px']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiThGroupComponent, [{
        type: Component,
        args: [{
                selector: 'tr[tuiThGroup]',
                template: "<ng-content></ng-content>\n<ng-container *ngIf=\"heads$ | async as headings\">\n    <ng-container\n        *ngFor=\"let key of table.columns\"\n        [ngTemplateOutlet]=\"headings[key.toString()]?.template || plain\"\n    >\n        <ng-template #plain>\n            <th *ngIf=\"!th && !heads.length\" tuiTh>{{ key.toString() }}</th>\n        </ng-template>\n    </ng-container>\n</ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [TUI_TABLE_PROVIDER]
            }]
    }], function () { return [{ type: TuiTableDirective, decorators: [{
                type: Inject,
                args: [forwardRef(() => TuiTableDirective)]
            }] }]; }, { heads: [{
            type: ContentChildren,
            args: [forwardRef(() => TuiHeadDirective)]
        }], th: [{
            type: ContentChild,
            args: [forwardRef(() => TuiThComponent)]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiTableModule, { declarations: function () { return [TuiTableDirective, TuiTbodyComponent, TuiThGroupComponent, TuiThComponent, TuiTdComponent, TuiTrComponent, TuiCellDirective, TuiHeadDirective, TuiRowDirective, TuiTheadDirective, TuiResizedDirective, TuiTableSortPipe]; }, imports: function () { return [CommonModule, PolymorpheusModule, TuiMapperPipeModule, TuiSvgModule]; }, exports: function () { return [TuiTableDirective, TuiTbodyComponent, TuiThGroupComponent, TuiThComponent, TuiTdComponent, TuiTrComponent, TuiCellDirective, TuiHeadDirective, TuiRowDirective, TuiTheadDirective, TuiTableSortPipe]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTableModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, PolymorpheusModule, TuiMapperPipeModule, TuiSvgModule],
                declarations: [
                    TuiTableDirective,
                    TuiTbodyComponent,
                    TuiThGroupComponent,
                    TuiThComponent,
                    TuiTdComponent,
                    TuiTrComponent,
                    TuiCellDirective,
                    TuiHeadDirective,
                    TuiRowDirective,
                    TuiTheadDirective,
                    TuiResizedDirective,
                    TuiTableSortPipe,
                ],
                exports: [
                    TuiTableDirective,
                    TuiTbodyComponent,
                    TuiThGroupComponent,
                    TuiThComponent,
                    TuiTdComponent,
                    TuiTrComponent,
                    TuiCellDirective,
                    TuiHeadDirective,
                    TuiRowDirective,
                    TuiTheadDirective,
                    TuiTableSortPipe,
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TABLE_FACTORY, TABLE_LABEL, TABLE_THRESHOLD, TUI_STUCK, TUI_STUCK_PROVIDER, TUI_TABLE_PROVIDER, TUI_TABLE_PROVIDERS, TuiCellDirective, TuiHeadDirective, TuiResizedDirective, TuiRowDirective, TuiTableDirective, TuiTableModule, TuiTableSortPipe, TuiTbodyComponent, TuiTdComponent, TuiThComponent, TuiThGroupComponent, TuiTheadDirective, TuiTrComponent, inputCountOptionsFactory, stuckFactory };

//# sourceMappingURL=taiga-ui-addon-table-components-table.js.map